"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceViews = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.PriceViews = function (props) {
    var price = props.price, originPrice = props.originPrice, _a = props.className, className = _a === void 0 ? "" : _a, isFlash = props.isFlash;
    return (React.createElement(styles_1.PriceViewGridBase, { key: "PriceViews", className: className, isFlash: isFlash },
        React.createElement("span", { className: "currentPrice" }, price),
        price !== originPrice && React.createElement("span", { className: "originPrice" }, originPrice)));
};
